import type { TaskTypeName } from './generated/gql-enums';

export const TASK_TYPE_ACCOUNT_SETUP = 'account_setup' satisfies TaskTypeName;
export const TASK_TYPE_FILE_UPLOAD = 'file_upload' satisfies TaskTypeName;
export const TASK_TYPE_INITIAL_INTAKE_FORM = 'initial_intake_form' satisfies TaskTypeName;
export const TASK_TYPE_ONBOARDING_FLOW = 'onboarding_flow' satisfies TaskTypeName;
export const TASK_TYPE_PRE_REVIEW_CHECK_IN = 'pre_review_check_in' satisfies TaskTypeName;
export const TASK_TYPE_SWIM_REQUEST = 'swim_request' satisfies TaskTypeName;
